<template>
  <div
    :class="[toggle ? 'toggle-container' : '', flex ? 'flex' : '']"
    :style="{
      borderTop: noTopBorder ? '' : border,
      borderBottom: last ? border : '',
      backgroundColor: highlighted ? '#D9F0EA' : '',
      color: highlighted ? '#E05484' : null
    }"
  >
    <img v-if="icon && !fontawesome" :src="require('@/assets/icons/' + icon)" class="icon" />
    <v-icon
      small
      color="#00A9B3"
      v-if="fontawesome"
      class="icon"
    >
      {{ icon }}
    </v-icon>
    <slot></slot>
    <div v-if="toggle" class="toggle-button">
      <v-switch
        hide-details
        dense
        :disabled="disabled"
        :value="toggleValue"
        @change="toggleInput">
      </v-switch>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListItem",
  props: {
    disabled: { default: false },
    noTopBorder: { default: false },
    border: { default: "1px solid #31b9be" },
    last: { default: false },
    highlighted: { default: false },
    icon: {},
    toggle: Boolean,
    value: {},
    fontawesome: {default: false},
    flex: { default: false }
  },
  data: function() {
    return {
      toggleValue: {}
    };
  },
  mounted() {
    this.toggleValue = this.value
  },
  methods: {
    toggleInput: function() {
      this.toggleValue = !this.toggleValue
      this.$emit('input', this.toggleValue)
      this.$emit("toggle-setting", this.toggleValue);
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  display: block;
  width: 100%;
  position: relative;
  text-align: left;
  height: 3rem;
  line-height: 3rem;
  padding: 0 5%;

  cursor: pointer;

 /* &:hover {
    background-color: #fafafa;
  }
*/
  & img,
  .icon {
    margin-right: 1rem;
  }
}

.flex {
  display: flex;
  align-items: center;
  line-height: normal;
}

.icon {
  width: 30px;
  vertical-align: middle;
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.toggle-button {
  display: flex;
  height: auto;
  width: auto;
  padding: 0;
}

.toggle {
  display: none;
}
.toggle + label {
  cursor: pointer;
  position: relative;
  outline: none;
  user-select: none;
  width: 40px;
  height: 20px;

  border-radius: 60px;
  transition: background 0.2s;
}
.toggle + label::before,
.toggle + label::after {
  content: "";
  display: block;
  position: absolute;
}
.toggle + label::before {
  right: 1px;
  left: 1px;
  top: 1px;
  bottom: 1px;
  background-color: #f1f1f1;
  border-radius: 60px;
  transition: background 0.2s;
}
.active + label::before {
  background-color: #E05484;
}
.toggle + label::after {
  top: -1px;
  left: 0;
  width: 22px;
  height: 22px;
  background-color: #fff;
  border-radius: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
}
.toggle:checked + label {
  &::before {
  }

  &::after {
    transform: translateX(20px);
  }
}

.toggle:disabled + label {
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=50);
  opacity: 0.5;
  cursor: default;
}
</style>
